module.exports = {"data":["cargill.com","CRGL-THIRDPARTY.COM","agresource.ca","awb.com.au","awb.com"]}


//////////////////
// WEBPACK FOOTER
// ./src/internalUserEmailDomains.json
// module id = 78
// module chunks = 1